import React from 'react'

import { Modal, Button, Col, Row, Form, Divider, Table } from '_zari/core'

import * as TallerService from 'services/taller.service'
import * as InventarioService from 'services/inventario.service'

const InformacionTallerModal = ({ show, handleClose, idTaller, idKardex }) => {
  const [infoTaller, setInfoTaller] = React.useState({})
  const [infoKardex, setInfoKardex] = React.useState({})
  const [detalles, setDetalles] = React.useState([])

  React.useEffect(() => {
    TallerService.obtenerxIdAsSoloLectura(idTaller).then(({ data }) => {
      setInfoTaller(data)
    })

    InventarioService.obtenerxIdAsSoloLectura(idKardex).then(({ data }) => {
      setInfoKardex(data)
    })

    InventarioService.obtenerxIdAsDetallesTaller(idKardex).then(({ data }) => {
      setDetalles(data)
    })
  }, [idTaller, idKardex])

  return (
    <>
      <Modal show={show} fullSize>
        <Modal.Header>
          <Row className='w-100'>
            <Col md={6}>
              <Modal.Title>Informacion Taller</Modal.Title>
            </Col>
            <Col md={6} className='text-right'>
              <Button tiny outline onClick={handleClose}>
                x
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label text='Titulo :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.titulo || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Fecha Ingreso :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.fechaIngreso || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Fecha Salida :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.fechaSalida || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Horas :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.horas || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Monto :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.monto || '--'} noPadding />
                </Col>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label text='Centro Costo :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.infoCentroCosto || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Servicio :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.infoServicio || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Sub Servicio 1 :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.infoSubServicio1 || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Sub Servicio 2 :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.infoSubServicio2 || '--'} noPadding />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Divider title='KARDEX' />
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label text='Titulo :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoKardex.titulo || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Fecha Emision :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText text={infoTaller.fechaEmision || '--'} noPadding />
                </Col>
              </Form.Group>
              <Form.Group>
                <Form.Label text='Documento :' noPadding md={3} alignRightAt='md' />
                <Col md={9}>
                  <Form.OnlyText
                    text={`${infoTaller.tipoDocumento || '--'} - ${infoTaller.serieDocumento || '--'} - ${
                      infoTaller.numeroDocumento || '--'
                    }`}
                    noPadding
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row>
          <Divider title='DETALLES' />
          <Table
            maxRowsShown={10}
            filas={detalles}
            headRows={[{ label: 'COD' }, { label: 'DESCRIPCION' }, { label: 'U. MEDIDA' }, { label: 'CANTIDAD' }]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell>{row.codigoProducto || '--'}</Table.Cell>
                <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
                <Table.Cell>{row.unidadMedida || '--'}</Table.Cell>
                <Table.Cell>{row.cantidad || '--'}</Table.Cell>
              </Table.Row>
            )}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default React.memo(InformacionTallerModal)
